// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2CtYB","errors":"Errors_errors__1SniR"};